import type { Action } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';
import type { BillingInfoState } from '../state/billing-info.state';
import { initialBillingState } from '../state/billing-info.state';
import {
  FetchBillingInfo,
  FetchBillingInfoError,
  FetchBillingInfoSuccess,
  UpdateBillingAddress,
  UpdateBillingAddressError,
  UpdateBillingEmail,
  UpdateBillingEmailError,
  UpdateBillingInfoAction,
  UpdateBillingInfoFail,
  UpdateBillingInfoSuccess,
  UpdateBillingPayingMethodError,
  UpdateBillingPaymentMethod,
  CheckForPaymentErrorsSuccess,
} from '../action/billing-info.action';

const billingInfoReducer = createReducer(
  initialBillingState,

  on(UpdateBillingInfoAction, (state: BillingInfoState) => {
    const newState = {
      ...state,
      loading: true,
      loaded: false,
      error: null,
    };

    return newState;
  }),
  on(UpdateBillingInfoSuccess, (state: BillingInfoState, { billingInfo }) => {
    const newState = {
      ...state,
      billingInfo: {
        ...billingInfo,
      },
      loading: false,
      loaded: true,
    };

    return newState;
  }),

  on(UpdateBillingInfoFail, (state: BillingInfoState, { error }) => {
    const newState = {
      ...state,
      loading: false,
      loaded: true,
      error,
    };

    return newState;
  }),

  on(FetchBillingInfo, (state: BillingInfoState) => {
    const newState = {
      ...state,
      loading: true,
      loaded: false,
      error: null,
    };
    return newState;
  }),
  on(FetchBillingInfoSuccess, (state: BillingInfoState, { billingInfo }) => {
    const newState = {
      ...state,
      billingInfo: {
        ...billingInfo,
      },
      loading: false,
      loaded: true,
    };

    return newState;
  }),
  on(FetchBillingInfoError, (state: BillingInfoState, { error }) => {
    const newState = {
      ...state,
      loading: false,
      loaded: true,
      error,
    };

    return newState;
  }),

  // Email Reducer
  on(UpdateBillingEmail, (state: BillingInfoState, { email }) => {
    const newState = {
      ...state,
      loading: true,
      loaded: false,
      error: null,
    };

    return newState;
  }),
  on(UpdateBillingEmailError, (state: BillingInfoState, { error }) => {
    const newState = {
      ...state,
      loading: false,
      loaded: true,
      error,
    };

    return newState;
  }),
  // Address Reducer
  on(UpdateBillingAddress, (state: BillingInfoState, { billingAddress }) => {
    const newState = {
      ...state,
      loading: true,
      loaded: false,
      error: null,
    };
    return newState;
  }),

  on(UpdateBillingAddressError, (state: BillingInfoState, { error }) => {
    const newState = {
      ...state,
      loading: false,
      loaded: true,
      error,
    };

    return newState;
  }),

  // §ayment redcuer

  on(UpdateBillingPaymentMethod, (state: BillingInfoState, { paymentMethod }) => {
    const newState = {
      ...state,
      loading: true,
      loaded: false,
      error: null,
      paymentMethod: { ...paymentMethod },
    };
    return newState;
  }),
  on(UpdateBillingPayingMethodError, (state: BillingInfoState, { error }) => {
    const newState = {
      ...state,
      loading: false,
      loaded: true,
      error,
    };
    return newState;
  }),

  on(CheckForPaymentErrorsSuccess, (state: BillingInfoState, { error, status }) => {
    const newState = {
      ...state,
      billingInfo: {
        ...state.billingInfo,
      },
      paymentMethodError: error || '',
      paymentMethodStatus: status,
    };
    return newState;
  }),
);

export function BillingInfoReducer(state: BillingInfoState | undefined, action: Action) {
  return billingInfoReducer(state, action);
}
